export const SINKS_FETCH_ERROR_MESSAGE = "An error occurred loading sink data";
